module.exports = __webpack_public_path__ + "img/assembly.dd00af3a.png";